import helpGuide_en from './help-guide_en.json'
import helpGuide_fr from './help-guide_fr.json'
import insurers_en from './insurers_en.json'
import insurers_fr from './insurers_fr.json'
import intro_en from './intro_en.json'
import intro_fr from './intro_fr.json'
import myClaims_en from './myclaim_en.json'
import myClaims_fr from './myclaim_fr.json'
import overviewWidget_en from './overview-widget_en.json'
import overviewWidget_fr from './overview-widget_fr.json'
import reviewClaim_en from './review-claim_en.json'
import reviewClaim_fr from './review-claim_fr.json'
import selectPrescription_en from './select-prescription_en.json'
import selectPrescription_fr from './select-prescription_fr.json'
import selectProduct_en from './select-product_en.json'
import selectProduct_fr from './select-product_fr.json'
import startRedirect_en from './start-redirect_en.json'
import startRedirect_fr from './start-redirect_fr.json'
import submitClaim_en from './submit-claim_en.json'
import submitClaim_fr from './submit-claim_fr.json'
import validateRx_en from './validate-rx_en.json'
import validateRx_fr from './validate-rx_fr.json'

const baseCAFlow_resources = {
  en: {
    ...intro_en,
    ...insurers_en,
    ...selectPrescription_en,
    ...selectProduct_en,
    ...validateRx_en,
    ...helpGuide_en,
    ...reviewClaim_en,
    ...submitClaim_en,
    ...myClaims_en,
    ...overviewWidget_en,
    ...startRedirect_en,
  },
  fr: {
    ...intro_fr,
    ...insurers_fr,
    ...selectPrescription_fr,
    ...selectProduct_fr,
    ...validateRx_fr,
    ...helpGuide_fr,
    ...reviewClaim_fr,
    ...submitClaim_fr,
    ...myClaims_fr,
    ...overviewWidget_fr,
    ...startRedirect_fr,
  },
}

export default baseCAFlow_resources
